import { render, staticRenderFns } from "./devSelfTestDetailModal.vue?vue&type=template&id=4dc11470&scoped=true"
import script from "./devSelfTestDetailModal.vue?vue&type=script&lang=js"
export * from "./devSelfTestDetailModal.vue?vue&type=script&lang=js"
import style0 from "./devSelfTestDetailModal.vue?vue&type=style&index=0&id=4dc11470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc11470",
  null
  
)

export default component.exports